export default {
  address: '',
  addressFloor: '',
  addressNumber: '',
  addressOffice: '',
  attendanceManagement: false,
  businessArea: '',
  bankAccountsAttributes: [
    {
      bankId: '',
      account: ''
    }
  ],
  businessLogo: {},
  businessName: '',
  collationPayment: '',
  communeId: '',
  communeName: '',
  compensationFund: {},
  compensationFundId: '',
  consultativeDtAccess: true,
  economicActivity: {},
  economicActivityId: '',
  email: '',
  emailDtNotifications: '',
  fantasyName: '',
  gratificationType: '',
  mobilizationPayment: '',
  nationalIdentification: '',
  payFirstLicenseDays: false,
  phone: '',
  phoneCountryCode: '+56',
  regionId: '',
  remunerations: false,
  representantsAttributes: [
    {
      firstLastName: '',
      identificationType: '',
      name: '',
      nationalIdentification: '',
      secondLastName: '',
      // image: {},
      imageSignature: {}
    }
  ],
  peopleManagement: true,
  safetyOrganization: {},
  safetyOrganizationId: '',
  signature: false,
  talentManagement: false,
  website: '',
  yearOfAgreement: ''
};
